import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrieveV0UsageAfterSaving = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVE_PACY_V0USAGE_AFTER_SAVING] : (state,action)=>action.status
})

export default RetrieveV0UsageAfterSaving
